import { useMatches } from 'react-router';

import type { CmsApiDocument } from '#/modules/cms/api/types/CmsApiDocument';
import type { CmsSplatLoaderData } from '#/modules/cms/documents/splat/CmsSplatLoaderData';

export function useRouteIsCmsDocument(): CmsApiDocument | undefined {
  const matches = useMatches();
  const lastMatch = matches[matches.length - 1];

  if (lastMatch.id !== 'cms-route') return;

  const loaderData = lastMatch.loaderData as CmsSplatLoaderData;
  if (loaderData?.type !== 'PAGE' && loaderData?.type !== 'POST') return;

  return loaderData.content;
}
